import { createUserManager } from "redux-oidc";

const origin = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ""
}`;

const settings = {
  authority: process.env.REACT_APP_AUTORITY,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: `${origin}/callback`,
  response_type: "code",
  scope: process.env.REACT_APP_SCOPE,
  post_logout_redirect_uri: `${origin}/logout`,
  silent_redirect_uri: `${origin}/silent_renew`,
  automaticSilentRenew: true,
};

const userManager = createUserManager(settings);

/**
 * Logout robusto verso Keycloak.
 *
 * `signoutRedirect()` da solo invia `id_token_hint` SOLO se l'utente oidc e'
 * ancora in sessionStorage. Se manca (token scaduto/rimosso, storage
 * desincronizzato) Keycloak non accetta `post_logout_redirect_uri` e l'utente
 * resta bloccato su una pagina di conferma/errore dell'IdP, con la sessione
 * SSO ancora attiva: al rientro viene ri-autenticato con lo stesso account e
 * torna su /auth/change-user (loop).
 *
 * Passando sempre `client_id` Keycloak riconosce il client anche senza
 * id_token_hint e completa il logout. Se anche questo fallisce (es. metadata
 * non raggiungibili) si ripiega su un login forzato (`prompt=login`) dopo aver
 * pulito lo stato locale.
 */
export const signout = (args = {}) =>
  userManager
    .signoutRedirect({
      ...args,
      extraQueryParams: {
        client_id: settings.client_id,
        ...(args.extraQueryParams || {}),
      },
    })
    .catch(async (error) => {
      console.error("signoutRedirect failed, forcing re-login", error);
      await userManager.removeUser().catch(() => {});
      return userManager.signinRedirect({ prompt: "login" });
    });

export default userManager;
